/* A2M Page Preview V2.7 — V2.6.1 stable drawer plus native Shopify search form. */
(() => {
  'use strict';
  const root = document.querySelector('[data-a2m-preview-root]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';
  const $ = s => root.querySelector(s);
  const sheet = $('[data-a2mpp-sheet]'), scroller = $('[data-a2mpp-scroll]');
  const heading = $('[data-a2mpp-heading]'), preview = $('[data-a2mpp-preview]');
  const full = $('[data-a2mpp-full]'), expandButton = $('[data-a2mpp-expand]');
  const actionLabel = $('[data-a2mpp-action-label]'), original = $('[data-a2mpp-original]');
  const grip = $('[data-a2mpp-grip-zone]');
  const uiLoading = $('[data-a2mpp-loading]'), loaderGraphic = $('[data-a2mpp-loader-graphic]');
  const headingWrap = $('[data-a2mpp-heading-wrap]'), headingImage = $('[data-a2mpp-heading-image]');
  const actions = $('.a2mpp-actions'), origLabel = $('[data-a2mpp-original-label]');
  let config;
  try { config = JSON.parse($('[data-a2mpp-config]').textContent); } catch(e) { console.warn('A2M page preview config invalid',e); return; }
  const ui = config.ui || {};
  const styleFont = () => {
    const fonts={inherit:'inherit',system:'-apple-system, BlinkMacSystemFont, sans-serif',serif:'Georgia, serif'};
    if(ui.headingFont==='custom' && /^https:\/\//i.test(ui.headingCustomFontUrl||'')){
      const ext=(ui.headingCustomFontUrl.split('?')[0].split('.').pop()||'').toLowerCase();
      if(['otf','ttf','woff','woff2'].includes(ext)){
        const f=new FontFace('A2M Preview Heading',`url("${ui.headingCustomFontUrl.replace(/"/g,'')}")`);
        f.load().then(loaded=>document.fonts.add(loaded)).catch(()=>{});
        root.style.setProperty('--a2mpp-heading-font','"A2M Preview Heading", sans-serif');
      }
    } else root.style.setProperty('--a2mpp-heading-font',fonts[ui.headingFont]||'inherit');
  };
  styleFont();
  const applyLoaderAlignment=()=>{
    loaderGraphic.style.justifyContent=ui.loaderHorizontal==='left'?'flex-start':ui.loaderHorizontal==='right'?'flex-end':'center';
    loaderGraphic.style.alignItems=ui.loaderVertical==='top'?'flex-start':ui.loaderVertical==='bottom'?'flex-end':'center';
    loaderGraphic.style.padding='24px';
  };
  applyLoaderAlignment();
  const loaderMode=ui.loaderMode||'spinner';
  if(loaderMode==='image'||loaderMode==='gif'){
    const url=loaderMode==='gif'?(ui.loaderGifUrl||ui.loaderGif):ui.loaderImage;
    if(url){const img=document.createElement('img');img.src=url;img.alt='';loaderGraphic.replaceChildren(img)}
    else {const el=document.createElement('span');el.className='a2mpp-built-in-spinner';loaderGraphic.replaceChildren(el)}
  }else if(loaderMode==='spinner'){const el=document.createElement('span');el.className='a2mpp-built-in-spinner';loaderGraphic.replaceChildren(el)}
  let loaderTimer=0;
  let entranceLoaderSeen=false;
  let loaderStartedAt=0;
  let loaderFinishTimer=0;
  const ENTRANCE_LOADER_MIN_MS=480;
  function finishLoaderAfterMinimum(token){
    clearTimeout(loaderFinishTimer);
    const remaining=Math.max(0,ENTRANCE_LOADER_MIN_MS-(performance.now()-loaderStartedAt));
    loaderFinishTimer=setTimeout(()=>{
      if(token!==requestId||state!=='expanded')return;
      hideLoader();
    },remaining);
  }
  function startEntranceLoader(){
    if(entranceLoaderSeen || loaderMode==='none')return false;
    entranceLoaderSeen=true;
    loaderStartedAt=performance.now();
    showLoader();
    return true;
  }
  function hideLoader(immediately=false){
    clearTimeout(loaderTimer);uiLoading.classList.remove('a2mpp-loading-in');
    if(immediately){uiLoading.hidden=true;return}
    const duration=Number(getComputedStyle(root).getPropertyValue('--a2mpp-loader-fade-out').trim().replace('ms',''))||250;
    loaderTimer=setTimeout(()=>{if(!uiLoading.classList.contains('a2mpp-loading-in'))uiLoading.hidden=true},duration+25);
  }
  function showLoader(){
    if(loaderMode==='none')return;
    clearTimeout(loaderTimer);uiLoading.hidden=false;
    requestAnimationFrame(()=>uiLoading.classList.add('a2mpp-loading-in'));
  }
  actions.hidden=!!ui.hideActions;
  actionLabel.hidden=!!ui.hideLeftText;
  expandButton.querySelector('.a2mpp-arrow').hidden=!!ui.hideLeftArrow;
  origLabel.hidden=!!ui.hideRightText;
  original.querySelector('.a2mpp-arrow').hidden=!!ui.hideRightArrow;
  const routes = (config.routes || []).filter(r => r.enabled && r.key && r.url);
  const previewHeight = Math.min(80,Math.max(30,Number(root.dataset.startHeight)||52));
  const expandedHeight = Math.min(100,Math.max(85,Number(root.dataset.expandedHeight)||96));
  const threshold = Number(root.dataset.dismissThreshold)||90;
  let state='closed',current=null,priorFocus=null,previousOverflow='',requestId=0,closeTimer=0;
  let activeLoad=null; // { url, token, promise }; one UI load per route, not per gesture
  const cache = new Map();
  const pending = new Map();
  const SLOW_UI_MS = 2800;
  // V2.5: Request only the policy/body section, never the entire storefront first.
  // Shopify section rendering avoids cart scripts, header, footer, and large page assets.
  const extractContent = (html, baseUrl) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const block = doc.querySelector('section.page-section .container') ||
      doc.querySelector('.page-section .container') ||
      doc.querySelector('#shopify-section-main-page .container') ||
      doc.querySelector('main .rte');
    if (!block) throw new Error('Page-content region unavailable');
    const safe = block.cloneNode(true);
    const isSearchPage = new URL(baseUrl, location.href).pathname.replace(/\/$/, '') === '/pages/search';
    // Preserve native GET-search form controls on /pages/search only.
    // Other informational pages retain their existing strict sanitization.
    const banned = isSearchPage
      ? 'script,style,link,iframe,object,embed,[onclick],[onerror],[onload]'
      : 'script,style,link,iframe,form,button,input,textarea,select,object,embed,[onclick],[onerror],[onload]';
    safe.querySelectorAll(banned).forEach(n => n.remove());
    if (isSearchPage) {
      safe.querySelectorAll('form').forEach(form => {
        const action = new URL(form.getAttribute('action') || '/search', baseUrl);
        if (action.origin !== location.origin || !/\/search\/?$/.test(action.pathname)) { form.remove(); return; }
        form.action = action.href;
        form.method = 'get';
      });
    }
    safe.querySelectorAll('[id]').forEach(n => n.removeAttribute('id'));
    safe.querySelectorAll('a[href]').forEach(a => {
      try { const dest = pageUrl(new URL(a.getAttribute('href'),baseUrl).href); if (dest) a.href = dest.href; else a.removeAttribute('href'); }
      catch (_) { a.removeAttribute('href'); }
    });
    safe.querySelectorAll('img[src],source[srcset]').forEach(el => {
      if (el.hasAttribute('src')) {
        try { el.src = new URL(el.getAttribute('src'),baseUrl).href; } catch (_) {}
      }
    });
    return safe.innerHTML;
  };
  async function requestHtml(url, timeoutMs) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), timeoutMs);
    try {
      const response = await fetch(url, { credentials:'same-origin', headers:{ Accept:'text/html' }, signal:controller.signal });
      if (!response.ok) throw new Error('Preview request HTTP '+response.status);
      return await response.text();
    } finally { clearTimeout(timeout); }
  }
  async function getPageBody(url) {
    if (cache.has(url)) return cache.get(url);
    if (pending.has(url)) return pending.get(url);
    const task = (async () => {
      // main-page.liquid renders {{ page.content }} in the destination page context.
      // The static rendering endpoint works regardless of that JSON template's dynamic section ID.
      const sectionURL = new URL(url);
      sectionURL.searchParams.set('section_id','main-page');
      let html;
      try { html = extractContent(await requestHtml(sectionURL.href, 4500), url); }
      catch (sectionError) {
        // Compatibility fallback for custom templates that don't expose main-page.
        try { html = extractContent(await requestHtml(url, 4500), url); }
        catch (pageError) { console.warn('[A2M Page Preview V2.6] Section and page request failed', sectionError, pageError); throw pageError; }
      }
      cache.set(url, html);
      return html;
    })();
    pending.set(url, task);
    try { return await task; }
    finally { if(pending.get(url)===task) pending.delete(url); }
  }
  const prefetch = url => { if (url && !cache.has(url)) getPageBody(url).catch(() => {}); };


  const pageUrl = (raw) => {
    try { const url = new URL(raw,location.href); return url.origin === location.origin && /^https?:$/.test(url.protocol) ? url : null; } catch(_) {return null;}
  };
  // Warm only the first configured route; avoid fetching an entire collection of pages at once.
  // This improves first-opening speed in mobile in-app browsers without blocking initial rendering.
  const warmRoute = routes.find(r => /shipping/i.test(r.key || '') || /shipping/i.test(r.url || '')) || routes[0];
  if (warmRoute) {
    const warmUrl = pageUrl(warmRoute.url);
    if (warmUrl) setTimeout(() => prefetch(warmUrl.href), 350);
  }

  const routeFor = (node) => {
    const marked = node.closest('[data-a2m-page-preview]');
    if(marked){const key=(marked.getAttribute('data-a2m-page-preview')||'').trim().toLowerCase();return routes.find(r=>r.key===key)||null;}
    const link=node.closest('a[href]');if(!link)return null;
    const matchedSelector=routes.find(r=>{if(!r.selector)return false;try{return link.matches(r.selector)}catch(_){return false}});
    if(matchedSelector)return matchedSelector;
    if(!config.interceptMatchedUrls)return null;
    const target=pageUrl(link.href); if(!target)return null;
    return routes.find(r => {const u=pageUrl(r.url);return u&&u.pathname.replace(/\/$/,'')===target.pathname.replace(/\/$/,'')})||null;
  };
  const setHeight=(value)=>{sheet.style.height=value+'dvh'};
  function setState(next){
    if(state === 'closed') return;
    const sameState = state === next;
    state=next;
    root.classList.remove('a2mpp-dragging');
    sheet.style.transform='';
    setHeight(next==='expanded'?expandedHeight:previewHeight);
    // A pointer-cancel or small drag often resolves to the SAME state.
    // Only reset scroll and change DOM visibility when a state ACTUALLY changes.
    if (sameState) return;
    const expanded=next==='expanded';
    preview.hidden=expanded;full.hidden=!expanded;
    actionLabel.textContent=expanded?(ui.collapseLabel||'back to preview'):(ui.expandLabel||'view full page');
    headingWrap.hidden=expanded && (current ? current.hideHeadingExpanded!==false : !!ui.hideHeadingExpanded);
    expandButton.querySelector('.a2mpp-arrow').textContent=expanded?'↓':'↑';
    if(expanded){
      scroller.scrollTop=0;
      loadFull();
    } else {
      // Hide spinner in preview but keep an in-flight request alive.
      hideLoader(true);
      scroller.scrollTop=0;
    }
  }
  // Search is a special interactive preview. Build its form directly in the
  // half-sheet so it works immediately without fetching/parsing an entire page.
  // It submits normally to Shopify's native /search route and never calls cart code.
  function renderSearchPreview(container){
    const outer=document.createElement('div');
    outer.style.cssText='padding:4px 0 22px;color:#202020;font-family:Helvetica,Arial,sans-serif;';
    const form=document.createElement('form');
    form.method='get';
    const shopifyRoot=(window.Shopify && window.Shopify.routes && window.Shopify.routes.root)||'/';
    form.action=shopifyRoot.replace(/\/?$/, '/')+'search';
    form.setAttribute('role','search');
    form.style.cssText='display:flex;align-items:stretch;gap:8px;width:100%;box-sizing:border-box;';
    const field=document.createElement('input');
    field.type='search';field.name='q';field.required=true;
    field.placeholder='search addicted2music.';
    field.setAttribute('aria-label','Search products');
    field.style.cssText='box-sizing:border-box;min-width:0;flex:1;width:100%;border:1px solid #cfcfcf;border-radius:999px;padding:14px 17px;background:#fff;color:#202020;font-family:Helvetica,Arial,sans-serif;font-size:16px;outline-offset:2px;';
    const type=document.createElement('input');type.type='hidden';type.name='type';type.value='product';
    const submit=document.createElement('button');submit.type='submit';submit.textContent='search';
    submit.style.cssText='border:0;border-radius:999px;background:#222;color:#fff;padding:14px 20px;font-family:Helvetica,Arial,sans-serif;font-size:15px;cursor:pointer;';
    form.append(field,type,submit);
    outer.append(form);
    container.appendChild(outer);
  }
  function openRoute(route){
    const url=pageUrl(route.url);if(!url)return;
    clearTimeout(closeTimer);requestId++;activeLoad=null;
    priorFocus=document.activeElement;current={...route,url:url.href};
    heading.textContent=route.title||'information.';
    headingWrap.style.justifyContent=ui.headingAlign==='center'?'center':ui.headingAlign==='right'?'flex-end':'flex-start';
    heading.style.textAlign=ui.headingAlign||'left';
    const headingSrc=route.headingImage||ui.headingImage;
    headingImage.hidden=!headingSrc;
    if(headingSrc)headingImage.src=headingSrc;
    else headingImage.removeAttribute('src');
    clearTimeout(loaderFinishTimer);entranceLoaderSeen=false;loaderStartedAt=0;
    hideLoader(true);
    preview.replaceChildren();
    if(route.image){const img=document.createElement('img');img.src=route.image;img.alt='';img.loading='lazy';preview.appendChild(img)}
    const isSearchRoute = url.pathname.replace(/\/$/,'') === '/pages/search';
    if(isSearchRoute){
      renderSearchPreview(preview);
    } else if(route.content){
      const box=document.createElement('div');box.innerHTML=route.content;
      box.querySelectorAll('script,iframe,object,embed,form').forEach(el=>el.remove());
      preview.appendChild(box);
    }
    full.textContent='';full.dataset.loaded='';original.href=url.href;original.hidden=!route.showOriginal;
    root.hidden=false;previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';
    state='opening';setState('preview');
    prefetch(url.href); // Start loading the original page immediately, before the user swipes upward.
    requestAnimationFrame(()=>{sheet.style.transform='';root.classList.add('a2mpp-open');sheet.focus({preventScroll:true})});
  }
  function close(){if(state==='closed')return;clearTimeout(loaderFinishTimer);hideLoader(true);requestId++;activeLoad=null;state='closed';root.classList.remove('a2mpp-dragging');sheet.style.transform='translate3d(0,105%,0)';root.classList.remove('a2mpp-open');document.documentElement.style.overflow=previousOverflow;
    clearTimeout(closeTimer);closeTimer=setTimeout(()=>{if(state==='closed'){root.hidden=true;current=null;if(priorFocus&&priorFocus.isConnected)priorFocus.focus({preventScroll:true})}},390)}
  // A delayed request must not monopolize the page with an endless-looking spinner.
  // Show a useful fallback quickly, but still replace it automatically when the fetch succeeds.
  function showSlowLoad(url) {
    full.replaceChildren();
    const notice = document.createElement('p');
    notice.textContent = 'this page is taking a moment to load.';
    notice.className = 'a2mpp-load-notice';
    const actions = document.createElement('div');
    actions.style.cssText = 'display:flex;flex-wrap:wrap;gap:20px;margin-top:18px;align-items:center';
    const link = document.createElement('a');
    link.href = url;
    link.textContent = 'open original page →';
    link.style.cssText = 'color:inherit;text-decoration:underline;text-underline-offset:3px';
    actions.append(link);
    full.append(notice, actions);
    original.hidden = false;
  }
  function loadFull(){
    if(!current || state!=='expanded')return;
    const url=current.url;
    const token=requestId;
    // The loader is a short, intentional entrance cue on first expansion only.
    // It is never restarted by small gestures, collapsing, or re-expanding.
    const newEntrance=startEntranceLoader();
    const finishReady=()=>{
      if(token!==requestId || state!=='expanded' || !current || current.url!==url)return;
      if(newEntrance)finishLoaderAfterMinimum(token);
      else if(entranceLoaderSeen && !uiLoading.hidden && full.dataset.loaded===url) finishLoaderAfterMinimum(token);
      else hideLoader(true);
    };
    if(full.dataset.loaded===url){finishReady();return;}
    if(cache.has(url)){
      full.innerHTML=cache.get(url);
      full.dataset.loaded=url;
      original.hidden=!current.showOriginal;
      finishReady();
      return;
    }
    // Reuse the active request; never clear the content or restart the animation.
    if(activeLoad && activeLoad.url===url && activeLoad.token===token)return;
    if(!full.childElementCount)full.dataset.loaded='';
    const operation={url,token,promise:null};
    activeLoad=operation;
    const slowTimer=setTimeout(()=>{
      if(activeLoad!==operation || token!==requestId || !current || current.url!==url || state!=='expanded' || full.dataset.loaded===url)return;
      hideLoader(true);
      showSlowLoad(url);
    },SLOW_UI_MS);
    operation.promise=getPageBody(url).then(content=>{
      if(token!==requestId || !current || current.url!==url)return;
      if(state!=='expanded')return; // cache is populated for next expansion
      if(full.dataset.loaded===url)return;
      full.innerHTML=content;
      full.dataset.loaded=url;
      original.hidden=!current.showOriginal;
      finishReady();
    }).catch(err=>{
      if(token!==requestId || !current || current.url!==url || state!=='expanded')return;
      if(full.dataset.loaded===url)return;
      hideLoader(true);
      showSlowLoad(url);
      if(!full.querySelector('.a2mpp-retry')){
        const retry=document.createElement('button');
        retry.type='button';retry.className='a2mpp-retry';
        retry.textContent='try again →';
        retry.style.cssText='border:0;background:transparent;color:inherit;text-decoration:underline;cursor:pointer;padding:12px 0;font:inherit';
        retry.addEventListener('click',()=>{
          if(state!=='expanded'||!current||current.url!==url)return;
          cache.delete(url);pending.delete(url);activeLoad=null;
          full.replaceChildren();
          entranceLoaderSeen=false;
          loadFull();
        });
        full.appendChild(retry);
      }
      console.warn('[A2M Page Preview V2.6.1] page load failed',err);
    }).finally(()=>{
      clearTimeout(slowTimer);
      if(activeLoad===operation)activeLoad=null;
    });
  }
  document.addEventListener('click', e=>{
    if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.altKey||e.shiftKey)return;
    const node=e.target instanceof Element ? e.target.closest('a[href],[data-a2m-page-preview]') : null;if(!node||root.contains(node))return;
    const route=routeFor(node);if(!route)return;
    const anchor=node.closest('a');if(anchor&&(anchor.target==='_blank'||anchor.hasAttribute('download')))return;
    e.preventDefault();e.stopImmediatePropagation();openRoute(route);
  },true);
  $('[data-a2mpp-backdrop]').addEventListener('click',close);
  $('[data-a2mpp-close]').addEventListener('click',close);
  expandButton.addEventListener('click',()=>setState(state==='expanded'?'preview':'expanded'));
  document.addEventListener('keydown',e=>{if(state!=='closed'&&e.key==='Escape'){e.preventDefault();close()}});
  // Pointer drag only on the dedicated grip. Scrolling the policy remains native.
  let drag=null;
  grip.addEventListener('pointerdown',e=>{if(e.button!==0||state==='closed')return;drag={id:e.pointerId,start:e.clientY,y:e.clientY,from:state};grip.setPointerCapture(e.pointerId);root.classList.add('a2mpp-dragging')});
  grip.addEventListener('pointermove',e=>{if(!drag||drag.id!==e.pointerId)return;drag.y=e.clientY;const delta=e.clientY-drag.start;
    // When expanding, resize in-place; when dismissing, follow the finger.
    if(drag.from==='preview'&&delta<0){setHeight(Math.min(expandedHeight,previewHeight+(-delta/window.innerHeight)*100));sheet.style.transform=''}
    else if(drag.from==='expanded'&&delta>0){setHeight(Math.max(previewHeight,expandedHeight-(delta/window.innerHeight)*100));sheet.style.transform=''}
    else sheet.style.transform=`translate3d(0,${Math.max(0,delta)}px,0)`;
  });
  function finishDrag(e,cancelled){if(!drag||drag.id!==e.pointerId)return;const d=drag;drag=null;root.classList.remove('a2mpp-dragging');const delta=d.y-d.start;
    if(cancelled){setState(d.from);return}
    if(d.from==='preview'&&delta>threshold){close();return}
    if(d.from==='preview'&&delta< -threshold){setState('expanded');return}
    if(d.from==='expanded'&&delta>threshold){setState('preview');return}
    setState(d.from);
  }
  grip.addEventListener('pointerup',e=>finishDrag(e,false));
  grip.addEventListener('pointercancel',e=>finishDrag(e,true));
  window.A2MPagePreview={version:'2.7-search',open:(key)=>{const route=routes.find(r=>r.key===String(key).toLowerCase());if(route)openRoute(route)},close,expand:()=>{if(state!=='closed')setState('expanded')}};
})();
